<footer class="main-footer">
  <div class="container-dynamic d-flex">
    <span class="m-auto"></span>
    Design & Developed by <a href="#"> Tgss</a>
  </div>
</footer>
